import { getUniFrame } from '@web3/utils';
import { Web3InfraGlobalConfig, web3InfraGlobalConfigStore } from './store/config';
import { initStore } from './store/userWallet';
import { debugLog } from './utils/common';
import { setWeb3WalletHubCenterOpt } from './wallet-hub/Web3WalletHubCenter';
import { onlyRunOnce } from './wallet-hub/misc';

export const initWeb3Infra = onlyRunOnce(async (c: Partial<Omit<Web3InfraGlobalConfig, 'hasConfigured'>>) => {
  if (!c.appName) {
    throw new Error('App Name is required');
  }
  debugLog('init web3 infra', c);
  if (c.loadUniframe) {
    // 防止SSR时候加载
    if (typeof window !== 'undefined') {
      getUniFrame();
    }
  }
  web3InfraGlobalConfigStore.setState(c);
  setWeb3WalletHubCenterOpt(web3InfraGlobalConfigStore.state.thirdWalletOpts);
  initStore();
});

/**
 * web3 团队内部使用的 config 钱包和infra的方法
 */
export const web3FeTeamUseInit = (appName: string) => {
  initWeb3Infra({
    appName,
    autoUpdateBalance: true,
    loadUniframe: true,
  });
};
